import { render, staticRenderFns } from "./FooterV2.vue?vue&type=template&id=6c117ad4&"
import script from "./FooterV2.vue?vue&type=script&lang=js&"
export * from "./FooterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports